export default "__VITE_ASSET__e5b749f8__"